export default __webpack_public_path__ + "c99d3c9819a3bdddbf18bc147491fe2f.jpg";